//CODE_START
import { createResourceStore } from "@/lib/resource";
import type { Shop } from "./Shop";
import type { User } from "./User";

export interface SecurityLog {
  id: string;
  event_type: "login" | "logout" | "password_change" | "account_lock" | string;
  event_description?: string | null;
  ip_address?: string | null;
  user_agent?: string | null;
  severity: "low" | "medium" | "high" | "critical";
  status: "success" | "failure" | "blocked";
  additional_data?: Record<string, any> | null;
  user_id: string;
  shop_id: string;
  created_at: string;
  updated_at: string;
  user: User;
  shop: Shop;
}

export const useSecurityLog = createResourceStore<SecurityLog>("security-logs");
//CODE_END
